console.log('ici')
import '@style/common/main-style'

import '@style/common/button.css'
import '@style/common/breadcrumbs.css'

import '@style/common/courseChapter/header.css'

import './index.css'

import '@core/components/course/Chapters'

import '@comp/customHtml/Snackbar'

import '@core/utils/text.ts'

import { deletePage } from '@utils/browserTest.ts'
import { loadCourseWithSlug } from '@service/courses.ts'
import { getUrlParams, updatePageTitle } from '@core/utils/url.ts'
import { useCourse } from '@core/composables/useCourse.ts'
import { loadCourseChapters } from '@service/chapters.ts'
import { generateCourseElements } from '@core/views/course/generate.ts'
import { generateCourseChapters } from '@core/components/course/Chapters/generate.ts'
import { removeCurrentPageClickEvent } from '@core/components/template/breadcrumbs'

document.addEventListener('DOMContentLoaded', () => {
  deletePage().then(async () => {
    const courseSlug = getUrlParams(/\/course\/([a-z0-9-]+)/)[0] || ''

    if (import.meta.env.DEV) {
      const course = await loadCourseWithSlug(courseSlug)

      generateCourseElements(document, course.title)
      updatePageTitle(course.title)

      const { initCourseHeader } = useCourse()
      initCourseHeader(course, document)
    }

    removeCurrentPageClickEvent()

    const chapters = await loadCourseChapters(courseSlug)
    generateCourseChapters(
      document,
      {
        courseSlug,
        chapters,
      },
      {
        baseElement: HTMLElement,
        customElements: window.customElements,
      },
    )
  })
})
